// extracted by mini-css-extract-plugin
export default {"container":"Reservation_container__OuvQI"};